import "./app.scss";
import aboutImg from "./assests/about.jpg";
import { BsTools } from "react-icons/bs";
import SkillCard from "./components/SkillCard";
import htmlImg from "./assests/html.png";
import cssImg from "./assests/css.png";
import bootstrapImg from "./assests/bootstrap.png";
import chakraImg from "./assests/chakra.png";
import expressImg from "./assests/express.png";
import jsImg from "./assests/javascript.png";
import mongoImg from "./assests/mongodb.png";
import nodeImg from "./assests/node.png";
import reactImg from "./assests/react.png";
import sassImg from "./assests/saas.png";
import ProjectCard from "./components/ProjectCard";
import rentyImg from "./assests/renty.png";
import VhubImg from "./assests/videohub.png";
import inventImg from "./assests/invent.png";
import ContactBox from "./components/ContactBox";
import { AiFillGithub, AiOutlineMail, AiOutlineDown } from "react-icons/ai";
import "./mediaqueries.scss";

function App() {
  return (
    <div className="App">
      {/* HERO Section */}
      <div className="hero">
        <nav>
          <h3>Asad ALi</h3>
          <button
            onClick={() => {
              window.location = "#contact";
            }}
          >
            Connect
          </button>
        </nav>
        <div className="container">
          <h1>Hi, I'm Asad. I build Full Stack Web Application</h1>
        </div>
        <p>
          Learn More About me <br />
          <AiOutlineDown />
        </p>
      </div>

      {/* About Section */}
      <div id="about" className="container">
        <div className="about">
          <img src={aboutImg} alt="Coding" />
          <div>
            <h4>ABOUT ME</h4>
            <h3>A dedicated Full Stack Developer</h3>
            <p>
              I'm a passionate and skilled web developer dedicated to crafting
              immersive and engaging digital experiences. Explore my portfolio
              to discover a collection of innovative projects that showcase my
              expertise in HTML, CSS, JavaScript, and various frameworks and
              libraries. Driven by a commitment to excellence, I consistently
              stay up-to-date with the latest industry trends and best practices
              to ensure cutting-edge solutions for my clients. Whether you're a
              startup in need of a digital presence or an established business
              looking to revamp your online platform, I'm here to turn your
              ideas into a reality
            </p>
          </div>
        </div>
      </div>
      {/* Skills */}
      <div id="skills" className="skills">
        <div className="container">
          <h2>
            Skills <BsTools />
          </h2>
          <div className="skill-grid">
            <SkillCard icon={htmlImg} text={"HTML"} />
            <SkillCard icon={cssImg} text={"CSS"} />
            <SkillCard icon={reactImg} text={"React"} />
            <SkillCard icon={jsImg} text={"JS"} />
            <SkillCard icon={sassImg} text={"Sass"} />
            <SkillCard icon={mongoImg} text={"MongoDB"} />
            <SkillCard icon={bootstrapImg} text={"BootStrap"} />
            <SkillCard icon={nodeImg} text={"Node JS"} />
            <SkillCard icon={chakraImg} text={"Chakra UI"} />
            <SkillCard icon={expressImg} text={"Express"} />
          </div>
        </div>
      </div>
      {/* Project Section */}
      <div id="projects" className="container">
        <div className="project-section">
          <h2>Projects</h2>
          <div className="project-grid">
            <ProjectCard
              imgSrc={inventImg}
              title={"Inventory Managment"}
              tech={[
                "react",
                "redux",
                "express",
                "sass",
                "mongoose",
                "cloudinary",
                "jwt",
              ]}
              demo={"https://inventory-managment-system-jade.vercel.app/"}
              source2={
                "https://github.com/Asad-Ali09/inventory-managment-frontend"
              }
              source={
                "https://github.com/Asad-Ali09/inventory-managment-backend"
              }
              desc={
                "This Inventory Management System application will allow a User with large amount of products to manage their inventory. A demo Account is provided in order to test the application"
              }
            />
            <ProjectCard
              imgSrc={rentyImg}
              title={"Car Rental App"}
              tech={["HTML5", "CSS3", "react", "sass"]}
              demo={"https://car-rental-app-six.vercel.app/"}
              source={"https://github.com/Asad-Ali09/car-rental-app"}
              desc={
                "This Car Rental application is frontend app made on React. It will allow a User to Book different rides based on their ratings and prices ."
              }
            />
            <ProjectCard
              imgSrc={VhubImg}
              title={"Video Hub"}
              tech={["react", "HTML5", "ChakraUI"]}
              demo={"https://video-hub-khaki.vercel.app/"}
              desc={
                "A simple frontend of Video Hub Website which allows user to watch and add videos"
              }
                source={"https://github.com/Asad-Ali09/video-hub"}
            />
          </div>
        </div>
      </div>

      {/* Contact Me */}
      <div id="contact" className="contact">
        <div className="container contact-container">
          <h2>Contact Me</h2>
          <div>
            <ContactBox
              icon={<AiOutlineMail />}
              title={"Email"}
              desc={"Let's get in touch"}
              handleCLick={() => {
                window.location = "mailto:masadali5433@gmail.com";
              }}
            />
            <ContactBox
              icon={<AiFillGithub />}
              title={"Github"}
              desc={"Check out my repos"}
              handleCLick={() => {
                window.open("https://github.com/Asad-Ali09?tab=repositories");
              }}
            />
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer>&copy; 2023. All rights reserved</footer>
    </div>
  );
}

export default App;
